"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import { MarketToggleCityLink } from "./MarketToggleCityLink";

export function MarketToggleCity({ children = "", city = "City" }) {
  return (
    <Block className={"nav-market-toggle-sub-section-container"} tag={"div"}>
      <Block className={"padding-global"} tag={"div"}>
        <Block className={"container-large"} tag={"div"}>
          <Block
            className={"nav-market-toggle-community-list-container"}
            tag={"div"}
          >
            <Block
              className={"nav-market-toggle-section-heading-copy"}
              tag={"div"}
            >
              <Block className={"nav-market-list-heading"} tag={"div"}>
                {city}
              </Block>
            </Block>
            <Block className={"nav-market-city-apt-list-slot"} tag={"div"}>
              {children ?? (
                <>
                  <MarketToggleCityLink text={"Alison Creek "} />
                  <MarketToggleCityLink />
                  <MarketToggleCityLink />
                  <MarketToggleCityLink />
                  <MarketToggleCityLink />
                  <MarketToggleCityLink />
                  <MarketToggleCityLink />
                  <MarketToggleCityLink />
                  <MarketToggleCityLink />
                  <MarketToggleCityLink />
                  <MarketToggleCityLink />
                </>
              )}
            </Block>
          </Block>
        </Block>
      </Block>
    </Block>
  );
}
